import Result, { EmptyResult } from '@package/services/src/Result';

import { GiftCardService } from './services';
import { DeleteGiftCardRequest, GetGiftCardsRequest, GiftCard, GiftCardApplied, GiftCardRequest } from './types';

export default class GiftCardInteractor {
  public constructor(private readonly giftCardService: GiftCardService) {}

  public getGiftCards(request?: GetGiftCardsRequest): Promise<Result<Array<GiftCard> | null>> {
    return this.giftCardService.getGiftCards(request);
  }

  public deleteGiftCard(request: DeleteGiftCardRequest): Promise<EmptyResult> {
    return this.giftCardService.deleteGiftCard(request);
  }

  public applyGiftCard(request: GiftCardRequest): Promise<Result<GiftCardApplied | undefined>> {
    return this.giftCardService.applyGiftCard(request);
  }
}
